var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWardrobe = function SvgWardrobe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16.76 6.76A4.584 4.584 0 0 1 24.582 10a1.25 1.25 0 0 1-2.5 0 2.083 2.083 0 1 0-4.166 0c0 2.37.92 4.216 2.804 5.645l13.158 7.309a4.583 4.583 0 0 1 2.358 4.008v1.371a4.583 4.583 0 0 1-4.584 4.584H8.32a4.583 4.583 0 0 1-4.583-4.584v-1.37c0-.001 0 0 0 0a4.585 4.585 0 0 1 2.358-4.009l11.762-6.534c-1.614-1.735-2.44-3.893-2.44-6.42 0-1.216.483-2.381 1.342-3.24Zm3.227 11.337L7.309 25.14a2.084 2.084 0 0 0-1.072 1.821v1.372a2.084 2.084 0 0 0 2.083 2.084h23.333a2.083 2.083 0 0 0 2.084-2.084v-1.371a2.085 2.085 0 0 0-1.072-1.822l-12.678-7.043Z",
    clipRule: "evenodd"
  })));
};
export default SvgWardrobe;